import axiosInstance from '../utils/axios';

class CalibrationService {
  async getQueue(page = 1, limit = 20) {
    const response = await axiosInstance.get('/admin/calibration/queue', {
      params: { page, limit },
    });
    return response.data;
  }

  async getCase(caseId) {
    const response = await axiosInstance.get(`/admin/calibration/cases/${encodeURIComponent(caseId)}`);
    return response.data;
  }

  async exportRawChunks({ userIdx, caseId, pairId = null } = {}) {
    const params = {};
    if (userIdx != null) params.userIdx = userIdx;
    if (caseId) params.caseId = caseId;
    if (pairId) params.pairId = pairId;
    const response = await axiosInstance.get('/admin/calibration/raw/export', { params });
    return response.data;
  }
}

const calibrationService = new CalibrationService();
export default calibrationService;
